/**
 * HomePage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from 'react';
import { Helmet } from 'react-helmet';

import MainBanner from '../../components/MainBanner';

import { Content } from './styledComponents';

export default function Home() {
  return (
    <Content>
      <Helmet>
        <title>Conmigo Vales</title>
      </Helmet>
      <MainBanner />
    </Content>
  );
}
